export default __webpack_public_path__ + "static/media/corporate.e1b00da4.jpg";